var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPortfolio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9043 6.28244C20.2008 5.68957 20.8067 5.31506 21.4696 5.31506H35.4696C36.1324 5.31506 36.7384 5.68957 37.0348 6.28244L40.5348 13.2824C40.8061 13.8249 40.7771 14.4692 40.4582 14.9851C40.1393 15.501 39.5761 15.8151 38.9696 15.8151H17.9696C17.3631 15.8151 16.7998 15.501 16.4809 14.9851C16.1621 14.4692 16.1331 13.8249 16.4043 13.2824L19.9043 6.28244ZM22.5511 8.81506L20.8011 12.3151H36.138L34.388 8.81506H22.5511Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.38623 17.3317C3.38623 14.4493 5.85242 12.3151 8.63623 12.3151H48.3029C51.0868 12.3151 53.5529 14.4494 53.5529 17.3317V45.7984C53.5529 48.6808 51.0868 50.8151 48.3029 50.8151H8.63623C5.85242 50.8151 3.38623 48.6808 3.38623 45.7984V17.3317ZM8.63623 15.8151C7.55406 15.8151 6.88623 16.6059 6.88623 17.3317V45.7984C6.88623 46.5243 7.55405 47.3151 8.63623 47.3151H48.3029C49.3851 47.3151 50.0529 46.5243 50.0529 45.7984V17.3317C50.0529 16.6058 49.3851 15.8151 48.3029 15.8151H8.63623Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio);
export default __webpack_public_path__ + "static/media/portfolio.e2872a07.svg";
export { ForwardRef as ReactComponent };